import { DEFAULT_PAGE_SIZE } from '@/constants';
import { ClassInfo, ClassStatus, CreateClassParams, ClassStudentInfo } from '@/types/class';
import { ListResponse } from '@/types/common';
import { CourseDetail } from '@/types/course';
import { requestWrapper } from '@/utils/request';

// 获取班级列表
export async function getClassList(
  params: {
    page?: number;
    page_size?: number;
    ids?: string; // 员工 ID 列表(字符串，如: '1,2,3')
    store_id?: number;
    teacher_id?: number;
    mobile?: string;
    status?: ClassStatus; // 班级状态
  } = {},
) {
  const defaultParams = {
    status: ClassStatus.Ongoing,
    page: 1,
    page_size: DEFAULT_PAGE_SIZE,
  };

  const mergedParams = {
    ...defaultParams,
    ...params,
  };

  return requestWrapper<ListResponse<ClassInfo>>('/api/class/list', {
    method: 'GET',
    params: mergedParams,
  });
}

// 新建班级
export async function createClass(params: CreateClassParams) {
  return requestWrapper<ClassInfo>('/api/class/create', {
    method: 'POST',
    data: params,
  });
}

// 编辑班级
export async function updateClass(
  id: number,
  params?: CreateClassParams | { status: ClassStatus },
  is_del?: number,
) {
  return requestWrapper<ClassInfo>('/api/class/update', {
    method: 'POST',
    data: {
      ...params,
      id,
      is_del,
    },
  });
}

// 班级详情
export async function getClassDetail(id: number) {
  return requestWrapper<ClassInfo>('/api/class/detail', {
    method: 'GET',
    params: { id },
  });
}

// 获取班课课程安排
export async function getCourseSchedule(params: { class_id: number; order_start_time: string }) {
  return requestWrapper<ListResponse<CourseDetail>>('/api/course_schedule/list', {
    method: 'GET',
    params,
  });
}

// 在班学员结课学员
export async function getEndedClassStudents(params: { status: ClassStatus }) {
  return requestWrapper<ClassStudentInfo>('/api/class/student/list', {
    method: 'GET',
    params,
  });
}

// 添加学员到班级
export async function addStudentToClass(params: { class_id: number; user_ids: number[] }) {
  return requestWrapper<{ success: boolean }>('/api/class/student/create', {
    method: 'POST',
    data: params,
  });
}

// 结课班级
export async function endClass(params: { id: number }) {
  return requestWrapper<{ success: boolean }>('/api/class/end', {
    method: 'POST',
    data: params,
  });
}

// 删除班级
export async function deleteClass(params: { id: number }) {
  return requestWrapper<{ success: boolean }>('/api/class/delete', {
    method: 'POST',
    data: params,
  });
}

// 编辑班级学员
export async function editClassStudent(params: {
  status: number;
  class_id: number;
  user_id: number;
}) {
  return requestWrapper<{ success: boolean }>('/api/class/student/update', {
    method: 'POST',
    data: params,
  });
}

// 学员换班
export async function changeClassStudent(params: {
  user_id: number;
  class_id: number;
  new_class_id: number;
}) {
  return requestWrapper<{ success: boolean }>('/api/class/change', {
    method: 'POST',
    data: params,
  });
}

// 重置请假次数
export async function resetLeaveCount(params: { class_id: number; user_ids: number[] }) {
  return requestWrapper<{ success: boolean }>('/api/class/student/reset_leave_count', {
    method: 'POST',
    data: params,
  });
}
